@if (!pwdChanged) {
  <lib-dialog-layout-inner-x
    [btnText]="'auth.reset_password' | transloco"
    (confirm)="resetPassword()"
    [title]="'auth.reset_password' | transloco"
    [disableSubmit]="form?.invalid"
  >
    <ng-template #content>
      <lib-reset-password-form (formInstance)="form = $event"></lib-reset-password-form>
    </ng-template>
  </lib-dialog-layout-inner-x>
} @else {
  <lib-dialog-layout-inner-x
    [btnText]="'global.signin' | transloco"
    [title]="'auth.reset_password' | transloco"
    (confirm)="close()"
    [disableSubmit]="form?.invalid"
  >
    <ng-template #content>
      <p>{{ 'auth.password_changed' | transloco }}</p>
    </ng-template>
  </lib-dialog-layout-inner-x>
}
